// import Benefits from "./Benefits";
// import ClubDays from "./ClubDays";
// import Magazine from "./Magazine";
// import Offers from "./Offers";
// import RtvExtra from "./RtvExtra";
// import TvAppAuth from "./TvAppAuth";
// import JoinOffer from "../Join/JoinOffer";

import lazyImport from "../../../utils/lazyImport/lazyImport";

const Benefits = lazyImport(() => import("./Benefits"));
const ClubDays = lazyImport(() => import("./ClubDays"));
const Magazine = lazyImport(() => import("./Magazine"));
const Offers = lazyImport(() => import("./Offers"));
const RtvExtra = lazyImport(() => import("./RtvExtra"));
const TvAppAuth = lazyImport(() => import("./TvAppAuth"));
const JoinOffer = lazyImport(() => import("../Join/JoinOffer"));
const BenefitsPage = lazyImport(() => import("./BenefitsPage"));

export default {
  Benefits,
  ClubDays,
  Magazine,
  Offers,
  RtvExtra,
  TvAppAuth,
  JoinOffer,
  BenefitsPage,
};
